// Used to get consistent conversion from smallest unit of monetary amounts to
// the common unit. The actual currency is never displayed as the split payout
// rules are currency agnostic. We will need to change this if we ever need
// to do stuff here with currencies that have an exponent other than 2.
export const EXAMPLE_VALUE_CURRENCY = 'NOK';
